import { Model } from 'modules/core/lib/mobx-rest'

interface ILegalGender {
  id: number
  gender_id: number
  legal_entity_id: number
}

class LegalGender extends Model<ILegalGender> {
  static urlRoot() {
    return '/legal_genders'
  }
}

export default LegalGender
